import { render } from "./bi-publish-data.vue?vue&type=template&id=3489acca"
import script from "./bi-publish-data.vue?vue&type=script&lang=js"
export * from "./bi-publish-data.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__